import type { ChatMessageModel } from '../client/SmartAssistantBackendClient';

export const flushSequencedBuffer = (
  targetChatId: string,
  state: { nextSeq: number; buffer: Map<number, string>; lastSeq: number },
  params: {
    sequencedFlushTimersRef: React.MutableRefObject<Map<string, number>>;
    getChatBuffer: (id: string, fallback: ChatMessageModel[]) => ChatMessageModel[];
    mergeMessages: (current: ChatMessageModel[], payload: any, eventName?: string) => ChatMessageModel[];
    setChatBuffer: (id: string, messages: ChatMessageModel[]) => void;
    activeChatIdRef: React.MutableRefObject<string | null>;
    setHistory: React.Dispatch<React.SetStateAction<ChatMessageModel[]>>;
  },
) => {
  const timerId = params.sequencedFlushTimersRef.current.get(targetChatId);
  if (timerId) {
    clearTimeout(timerId);
    params.sequencedFlushTimersRef.current.delete(targetChatId);
  }

  const pendingSeqs = Array.from(state.buffer.keys()).sort((a, b) => a - b);
  if (pendingSeqs.length === 0) return;

  let merged = params.getChatBuffer(targetChatId, []);

  for (const seq of pendingSeqs) {
    const chunk = state.buffer.get(seq) ?? '';
    state.buffer.delete(seq);
    merged = params.mergeMessages(merged, { role: 'assistant', content: chunk, isPartial: true }, 'sequenced');
  }

  state.lastSeq = Math.max(state.lastSeq, pendingSeqs[pendingSeqs.length - 1]);
  state.nextSeq = Math.max(state.nextSeq, pendingSeqs[pendingSeqs.length - 1] + 1);
  params.setChatBuffer(targetChatId, [...merged]);
  if (params.activeChatIdRef.current === targetChatId) {
    params.setHistory(merged);
  }
};
